import { Component } from '@angular/core';
import { ApiService } from '@Services';
import { AdminService } from '@Services';
import { Observable } from 'rxjs';
import { AsyncPipe, DatePipe } from '@angular/common';
import { Notification } from '@Models';
import moment from 'moment';

interface DataDateExtract {
  details: string;
  summary: string;
}

@Component({
  selector: 'app-data-dates',
  imports: [AsyncPipe, DatePipe],
  templateUrl: './data-dates.component.html',
  styleUrl: './data-dates.component.css',
})
export class DataDatesComponent {
  dataDateExtract$: Observable<DataDateExtract> | null = null;
  url = `LatestLoadDate`;

  notificationExtract$: Observable<Notification[] | null> | null = null;
  constructor(
    private _apiService: ApiService,
    private _adminService: AdminService,
  ) {
    this.dataDateExtract$ = this._apiService.get(`${this.url}`);
    this.notificationExtract$ = this._adminService.getAllNotifications();
  }

  isDataUptodate(data: { details: string; summary: string }): boolean {
    const now = moment();
    const twentyfourHoursAgo = moment().subtract(24, 'hours');
    const detailsDate = moment(data.details);
    const summaryDate = moment(data.summary);
    return !(detailsDate.isBetween(twentyfourHoursAgo, now) && summaryDate.isBetween(twentyfourHoursAgo, now));
  }
}
